import React, {Component} from 'react';
import BaseTable from "./BaseTable";
import { getMaxWidth } from '../../../statisticalAnalysis/statisticsTable/utils';

/**
 * creat by tianruojun
 * @description 表格模板
 * @class TableTemplate
 * @extends {Component}
 */
export default class TableTemplate extends Component {
    static defaultProps = {
        defaultItemWidth: 100,
        maxHeight: 100,
        columns:[],
        maxWidth: 0
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        const observer = new ResizeObserver(e=>{
            e.forEach(entry=>{
                this.props.onResize(entry.target.offsetHeight);
            });
        });
        const target = document.querySelector('.TableTemplate .ant-table-thead');
        target&&observer.observe(target)
    }

    render() {
        let {columns,defaultItemWidth,maxHeight,dataSource,handleTableChange } = this.props;
        let scrollX = this.getScrollX(columns,defaultItemWidth);
        let scrollY = this.getScrollY(maxHeight,dataSource);
        return (
            <div className={'TableTemplate'}>
                <BaseTable
                    rowKey="id"
                    columns={columns}
                    dataSource={dataSource}
                    // x 当前表格最大宽度 y 最大高度
                    //scroll={{ ...scrollX,...scrollY}}
                    onChange={(pagination, filters, sorter)=>{handleTableChange(pagination,filters, sorter)}}
                    {...this.props}
                />
                <style>{`
                    .ant-table-fixed-header .ant-table-scroll .ant-table-header{
                        padding-bottom:0px !important;
                    }
                    .TableTemplate .ant-table-column-title {
                        white-space: nowrap;
                    }
                    .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body{
                        overflow:auto !important
                    }
                    `}</style>
            </div>
        )
    }
    thisPageMargin = 30;
    thisPagePadding = 64;
    // 如果当前表格宽度大于最大宽度，则中间需要滚动，否则不需要滚动
    getScrollX = (columns,defaultItemWidth) => {
        let scrollX = {};
        let maxWidth = this.props.maxWidth || getMaxWidth(this.thisPageMargin+this.thisPagePadding);
        let columnsWidth = this.getColumnsWidth(columns,defaultItemWidth) || 0;
        if(columnsWidth > maxWidth) {
            scrollX.x = columnsWidth
        }
        return scrollX
    };

    getScrollY = (maxHeight,dataSource) => {
        let scrollY = {};
        if(dataSource?.length) {
            scrollY.y = maxHeight
        }
        return scrollY
    };

    getColumnsWidth = (columns,defaultItemWidth) => {
        let columnsWidth = 0;
        if(columns?.length) {
            columns.forEach(column=>{
                if(column?.width) {
                    columnsWidth+=column.width
                } else {
                    columnsWidth+=defaultItemWidth
                }
            })
        }
        return columnsWidth
    };

}